var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"rose-chart"}},[_c('div',{staticClass:"rose-chart-title"},[_vm._v("用户类型分布")]),_c('dv-charts',{attrs:{"option":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }